import { Component, OnInit } from "@angular/core";
import { SignupService } from "./signup.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.less"]
})
export class AppComponent implements OnInit {
	isTabletOrMobile: boolean;
	isAutomated: boolean;

	constructor(private _signupService: SignupService) {}

	ngOnInit() {
		// append fullstory script only if not running tests
		this.isAutomated = (navigator) ? navigator.webdriver : false;
		if (!this.isAutomated) {
			const fullstory = document.createElement("script");
			fullstory.type = "text/javascript";
			fullstory.src = "./assets/js/fullstory.js";
			document.getElementsByTagName("head")[0].appendChild(fullstory);
		}
		// if no local storage show error message and do not allow user to proceed
		this._signupService.checkForLocalStorage();
	}

}
